'use client';

import { createClient } from '@/lib/supabase/client';

const SETTINGS_KEY = 'private_mode';

export async function getPrivateMode(): Promise<boolean> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('site_settings')
    .select('value')
    .eq('key', SETTINGS_KEY)
    .single();

  if (error || !data) return false;
  return data.value === true;
}

export async function setPrivateMode(enabled: boolean): Promise<void> {
  const supabase = createClient();
  await supabase
    .from('site_settings')
    .update({ value: enabled, updated_at: new Date().toISOString() })
    .eq('key', SETTINGS_KEY);

  // Dispatch a custom event so other components on the same tab can react immediately
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('privateModeChange', { detail: { enabled } }));
  }
}
